module.exports = "pegasus/assets/themelp1/charity/110.png";